import RSVPBadge from './RSVPBadge';

export default RSVPBadge;
